<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ext_split"><i><span class="right_1" epub:type="pagebreak" id="page_xv" title="xv"></span></i><b>TO THE CITIZENS OF SEMPERA</b></p>
<p class="ext1"><i>A NOTICE for the capture of Jules Ember of Crofton, murderer of the First Queen, the late Savior of Sempera, the Lady of Centuries; and of Lord Roan Gerling, beloved son of Lord Nicholas Gerling and Lady Verissa Gerling, devoted brother of Lord Liam Gerling.</i></p>
<p class="ext"><i>A reward of five hundred years of blood-iron is offered for the murderess’s living capture and delivery to Queen Ina Gold’s soldiers.</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062653710_Frontmatter.vue?b5fc33a8